/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useCallback, useState } from 'react';

export const useInput = ({ id = '', initialState, errorText, invalidHandler }) => {
  const [value, setValue] = useState(initialState);
  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);

  const onChange = useCallback((event) => {
    setValue(event.target.value);
    setErrorMessage('');
  }, []);

  const onBlur = useCallback(
    (event) => {
      const isValidValue = invalidHandler(event.target.value);
      const inValidMessage = isValidValue ? '' : errorText;

      setErrorMessage(inValidMessage);
      setIsValid(inValidMessage.length === 0);
    },
    [errorText, invalidHandler],
  );

  return {
    id,
    value,
    errorMessage,
    isValid,
    onChange,
    onBlur,
    setErrorMessage,
    setValue,
    setIsValid,
  };
};
